import { render, staticRenderFns } from "./courseCreaterPay.vue?vue&type=template&id=4a7e6da0&scoped=true"
import script from "./courseCreaterPay.vue?vue&type=script&lang=js"
export * from "./courseCreaterPay.vue?vue&type=script&lang=js"
import style0 from "./courseCreaterPay.vue?vue&type=style&index=0&id=4a7e6da0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e6da0",
  null
  
)

export default component.exports